import $ from 'jquery'
import Swiper from 'swiper'
import Vue from 'vue'
import { destroyVideos, setupVideos } from '../_video'
import eventBus from '../eventBus'

import '../../../scss/app/news_article.scss'

/**
 * @type {HTMLElement}
 */
const carouselView = document.querySelector('.article__media-large .swiper')
if (carouselView) {
  const carousel = new Swiper(carouselView, {
    autoHeight: true,
  })

  const thumbnails = document.querySelectorAll('.js-article-media-thumb')
  if (thumbnails.length) {
    const onThumbClick = (index) => () => {
      carousel.slideTo(index)
    }

    const followCarousel = () => {
      const previous = carousel.previousIndex
      const selected = carousel.realIndex
      if (previous !== undefined) {
        thumbnails[previous].classList.remove('is-selected')
      }
      thumbnails[selected].classList.add('is-selected')
    }

    thumbnails.forEach((thumbNode, index) => {
      const onClick = onThumbClick(index)
      thumbNode.addEventListener('click', onClick, false)
    })

    carousel.on('realIndexChange', () => {
      const previous = carousel.previousIndex
      const selected = carousel.realIndex

      destroyVideos(carousel.slides[previous])
      setupVideos(carousel.slides[selected])
      followCarousel()
    })
    followCarousel()
  }
}

const photoButtons = document.querySelectorAll('.js-article-media-photo')
photoButtons.forEach((photoButton, index) => {
  photoButton.addEventListener(
    'click',
    () => {
      eventBus.$emit('open-article-photo-modal', index)
    },
    false,
  )
})

const articleModalApp = document.getElementById('js-article-photos-modal-app')
if (articleModalApp) {
  new Vue({
    el: '#js-article-photos-modal-portal',
    template: '<portal-target name="article-photos-modal"></portal-target>',
  })

  new Vue({
    el: articleModalApp,
    template: '#article-photos-modal-template',
    props: {
      srcPhotos: Array,
      photoUrlTemplate: String,
      photoDownloadUrlTemplate: String,
      filesUrl: String,
    },
    propsData: {
      srcPhotos: JSON.parse(articleModalApp.dataset.photos),
      photoUrlTemplate: articleModalApp.dataset.photoUrlTemplate,
      photoDownloadUrlTemplate: articleModalApp.dataset.photoDownloadUrlTemplate,
      filesUrl: articleModalApp.dataset.filesUrl,
    },
    data: {
      modalOpen: false,
      modalPhoto: null,
    },
    computed: {
      photos() {
        return this.srcPhotos.map((photo) => {
          const alteredPhoto = photo
          alteredPhoto.shareUrl = this.getPhotoUrl(photo)
          alteredPhoto.downloadUrl = this.getPhotoDownloadUrl(photo)
          return alteredPhoto
        })
      },
    },
    methods: {
      getPhotoBackgroundStyle(src) {
        return `url("${src}")`
      },
      getPhotoUrl(photo) {
        return this.photoUrlTemplate.replace('0000', photo.id)
      },
      getPhotoDownloadUrl(photo) {
        return this.photoDownloadUrlTemplate.replace('0000', photo.id)
      },
      onPhotoClicked(photo) {
        this.showPhotoInModal(photo)
      },
      showPhotoInModal(photo) {
        this.modalPhoto = photo
        this.$nextTick(() => {
          this.modalOpen = true
        })
      },
      closeModal() {
        this.modalOpen = false
        this.modalPhoto = null
      },
      modalGoLeft() {
        const currentIdx = this.photos.indexOf(this.modalPhoto)
        this.modalPhoto = this.photos[currentIdx - 1 < 0 ? this.photos.length - 1 : currentIdx - 1]
      },
      modalGoRight() {
        const currentIdx = this.photos.indexOf(this.modalPhoto)
        this.modalPhoto = this.photos[currentIdx + 1 >= this.photos.length ? 0 : currentIdx + 1]
      },
    },
    watch: {
      modalOpen(newVal) {
        this.$nextTick(() => {
          if (newVal) {
            this.$refs.modal.focus()
          }
        })
      },
    },
    mounted() {
      this.$nextTick(() => {
        eventBus.$on('open-article-photo-modal', (index) => {
          this.showPhotoInModal(this.photos[index])
        })

        //
        // Modal keyboard shortcuts
        //

        $(this.$refs.modal)
          .add(document)
          .on('keydown', (ev) => {
            if (!this.modalOpen) {
              return true
            }

            ev.stopPropagation()

            if (ev.keyCode === 27) {
              this.closeModal()
              return false
            }

            // Left arrow
            if (ev.keyCode === 37) {
              this.modalGoLeft()
              return false
            }

            // Right arrow
            if (ev.keyCode === 39) {
              this.modalGoRight()
              return false
            }

            return true
          })
      })
    },
  })
}
